import { MessageResponse } from "./MessageResponse";
import { PaginatedListResponse } from "./paging";

export interface ChatChannelResponse {
    id: number;
    renterProfileId: number;
    providerProfileId: number;
    renterId: number;
    providerId: number;
    createdAtDate: Date;
}

export enum RentalStatus {
    MESSAGE_SENT = "message_sent",
    IN_RENT = "in_rent",
    RENT_FINISHED = "rent_finished",
    ARCHIVED = "archived"
}

export interface RentalDetailResponse {
    id: number;
    amount: number;
    state: RentalStatus;
    product: ProductRentalResponse;
    startDate: Date;
    endDate: Date;
}

export interface ProductRentalResponse {
    id: number;
    title: string;
    imageUrl: string;
    location: string;
    dayPrice: number;
}

export interface ChatChannelData {
    rental: RentalDetailResponse;
    chat: ChatChannelResponse
}

export interface ChatChannelListResponse {
    id: number;
    renterId: number;
    providerId: number;
    createdAtDate: Date;
    senderProfileName: string;
    senderProfilePicUrl: string;
    senderVerified: boolean;
    lastMessageId?: number;
    lastMessageAtDate?: Date;
    lastMessageUserId?: number;
    lastMessageMessage?: string;
    lastMessageDocumentId?: number;
    lastMessageSeen?: boolean;
    lastMessasgePublicProfilePicUrl?: string;
    buyerApproval: boolean;
    sellerApproval: boolean;
    newMessage?: boolean
}

export interface NewChannelMessageFromSocket {
    lastMessageId?: number;
    lastMessageAtDate?: Date;
    lastMessageUserId?: number;
    lastMessageMessage?: string;
    lastMessageDocumentId?: number;
}

export interface RentalListElementResponse {
    id: number;
    product: ProductRentalResponse;
}

export interface UserChannelElementListResponse {
    rental: RentalListElementResponse;
    chat: ChatChannelListResponse;
}

export interface MessagesListResponse extends PaginatedListResponse<MessageResponse> {
    firstUnseenMessageId?: number;
}